export default __webpack_public_path__ + "static/media/django.d51a8aa4.svg";